export enum LandingPageTypeEnum {
  SETTING_LAYOUT = 'setting-layout',
  UPLOAD_ZIP = 'upload-zip',
}
